import { render, staticRenderFns } from "./CompraMaterialesEdit.vue?vue&type=template&id=8cf9ce1e&scoped=true&"
import script from "./CompraMaterialesEdit.vue?vue&type=script&lang=ts&"
export * from "./CompraMaterialesEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf9ce1e",
  null
  
)

export default component.exports